import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class ClienteService {
  constructor(
    private http: HttpClient
  ) { }

  atualizarCliente(cliente) {
    return this.http
      .put(urls.apiBase + '/Clientes/Atualizar', cliente);
  }

  obterInfoPorId(id: string) {
    return this.http
      .get(`${urls.apiBase}/Pessoas/ObterInfoPorId?id=${id}`, {
        withCredentials: false
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/cliente/cliente.service.ts